import { useCallback } from "react";
import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";

const util = createTrackingUtils({
  name: "flights_web_mdot_pax_before_cp",
  defaultStage: 1,
  stages: {
    main: 1,
    direct: 2,
    meta: 3,
    solo: 4,
    family: 5,
    weekend: 6,
    long: 7,
    us: 8,
    nonus: 9
  },
  goals: {}
});

export default util;

export function useFlightsWebMdotPaxBeforeCp() {
  const { isDirect, isSolo, isAmerican, isPb, isMobile, isLongHaul, isWeekendStay, isFamily } = useProfiler();

  const stages = useCallback(() => {
    util.stages.main();
    if (isDirect()) util.stages.direct();
    if (!isDirect()) util.stages.meta();
    if (isSolo()) util.stages.solo();
    if (isFamily()) util.stages.family();
    if (isWeekendStay()) util.stages.weekend();
    if (isLongHaul()) util.stages.long();
    if (isAmerican()) util.stages.us();
    if (!isAmerican()) util.stages.nonus();
  }, [isDirect, isSolo, isAmerican, isLongHaul, isWeekendStay, isFamily]);

  const isVariant = useCallback(() => {
    if (!isMobile()) return false;
    if (isPb()) return false;
    stages();
    return !!util.trackWithDefaultStage();
  }, [isMobile, stages, isPb]);

  return { isVariant };
}
